import openErrorModal from "../../Error/ErrorModal";
import { openBackendValidationErrorModal } from "../../Error/ErrorUtilities";
import { fetchUpdateVariantModal, updateVariant } from "../../HTTPRequests/VariantRequests";
import Mediator from "../../Utilities/Mediator";
import DeleteVariantModal from "./DeleteVariantModal";
import VariantBaseModal from "./VariantBaseModal";

export default class UpdateVariantModal extends VariantBaseModal {
	itemId: string;
	serviceId: string;
	modalDiv: HTMLDivElement;

	constructor(itemId: string, serviceId: string) {
		super();
		this.modalDiv = document.createElement('div');
		this.itemId = itemId;
		this.serviceId = serviceId;
	}

	public addUpdateModalsClickListeners() {
		const rows: NodeListOf<HTMLTableRowElement> = document.querySelectorAll('.variant-row');
		rows.forEach(row => {
			row.onclick = (event) => {
				event.stopPropagation();
				document.body.append(this.loadingScreen);
				this.fetchUpdateModal(row);
			}
		});
	}

	private fetchUpdateModal(row: HTMLTableRowElement) {
		fetchUpdateVariantModal(this.serviceId, row.id)
			.then((response: string) => {
				this.openUpdateModal(response, row.id);
			}, () => { //backend error
				openErrorModal();
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}

	private openUpdateModal(modalHTMLString: string, id: string) {
		document.body.appendChild(this.modalDiv);
		this.modalDiv.innerHTML = modalHTMLString;

		this.addInputNumberEventsListeners("#update-variant-modal");
		new DeleteVariantModal(this.itemId, this.serviceId, id, this.modalDiv).addDeleteModalClickListener();
		this.addUploadImageChangeEventListener();
		this.addModalButtonsClickListeners(id);
		this.addDescriptionModalEventsListeners(this.modalDiv);
	}

	private addModalButtonsClickListeners(id: string) {
		window.onclick = (event) => {
			if (event.target === this.modalDiv.firstElementChild) {
				this.modalDiv.remove();
			}
		}

		const img: HTMLImageElement = document.querySelector('#update-variant-modal img[alt="close icon"]');
		img.onclick = () => {
			this.modalDiv.remove();
		}

		const saveButton: HTMLButtonElement = document.querySelector('#update-variant-modal button + button');
		saveButton.onclick = () => {
			this.saveUpdatedVariant(id);
		}
	}

	private saveUpdatedVariant(id: string) {
		const form: HTMLFormElement = document.querySelector("#update-variant-modal form");
		let { valid, variantFormData } = this.getModalData(form);
		if (valid) {
			document.body.append(this.loadingScreen);
			variantFormData.append("id", id);
			this.updateVariant(variantFormData);
		} else {
			form.reportValidity();
		}
	}

	private updateVariant(variantFormData: FormData) {
		updateVariant(this.serviceId, variantFormData)
			.then(() => {
				this.modalDiv.remove();
				Mediator.emit("variantCrudOperationFinished");
			}, (error) => { //backend error
				openBackendValidationErrorModal(error);
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				this.loadingScreen.remove();
			});
	}
}


